// 机器人接口
import { get, post, post1,post2,post3 } from '../../utils/request';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 新增
    async add({ commit }, payload) {
      const res = await post2('system/advice/add',payload);
      return res;
    },
//多图上传
async postfile({ commit }, payload) {
  const res = await post3('file/postfile',payload);
  return res;
},
//查询投诉建议列表
async findList({ commit }, payload) {
  const res = await get('system/advice/list',payload);
  return res;
},
//获取投诉建议详细信息
async listDetail({ commit }, payload) {
  const res = await get('system/advice/'+payload);
  return res;
},
  },
};
